/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Signal_LaunchesInputs */

const en_directory_builders_signal_launches = /** @type {(inputs: Directory_Builders_Signal_LaunchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launches`)
};

const zh_directory_builders_signal_launches = /** @type {(inputs: Directory_Builders_Signal_LaunchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布次数`)
};

/**
* | output |
* | --- |
* | "Launches" |
*
* @param {Directory_Builders_Signal_LaunchesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_signal_launches = /** @type {((inputs?: Directory_Builders_Signal_LaunchesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Signal_LaunchesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_signal_launches(inputs)
	return zh_directory_builders_signal_launches(inputs)
});
export { directory_builders_signal_launches as "directory.builders.signal_launches" }